/**
 * Created by Florin David on 30/06/2020.
 */
import { ProductFamily } from 'types/product-family'
import Action, { SET_PRODUCT_FAMILY } from 'constants/action-types'

/**
 * Generic errors
 */
export default (
  state = ProductFamily.scloud,
  action: Action,
): ProductFamily => {
  switch (action.type) {
    case SET_PRODUCT_FAMILY:
      return action.payload
    default:
      return state
  }
}
